import { render, staticRenderFns } from "./paymentSettings.vue?vue&type=template&id=44393380&scoped=true"
import script from "./paymentSettings.vue?vue&type=script&lang=js"
export * from "./paymentSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44393380",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44393380')) {
      api.createRecord('44393380', component.options)
    } else {
      api.reload('44393380', component.options)
    }
    module.hot.accept("./paymentSettings.vue?vue&type=template&id=44393380&scoped=true", function () {
      api.rerender('44393380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/paymentSettings.vue"
export default component.exports